import React from "react"
import tw, { styled } from "twin.macro"

import { SlideProps } from "."

import Container from "../components/container"
import NextPageButton from "../components/nextPageButton"
import SlideSection from "../components/slideSection"
import TimeSelector from "../components/timeSelector"
import NextPageContainer from "../components/nextPageContainer"
import IconJobSecurity from "../icons/iconJobSecurity"

const Columns = styled.div`
  ${tw`flex flex-col lg:flex-row items-center justify-center w-full`}
`

const MediumThreeQuarters = styled.div`
@media (max-width: 768px) {
  width: 70vw;
}
  ${tw`lg:w-3/5 flex flex-col items-center justify-center`}
`

const MediumOneQuarter = styled.div`
  width: 15% ${tw`lg:w-2/6 flex flex-col items-end justify-center`};
`

const Instructions = styled.p`
  ${tw`hidden md:block w-64 text-center  text-sm mb-6`}
`

const InstructionsSmall = styled.p`
  ${tw`md:hidden w-64 text-center  text-sm mb-6`}
`

const JobSlide: React.SFC<SlideProps> = ({
  slideVisible,
  nextButtonClicked,
}) => {
  return (
    <SlideSection autoHeightResponsive>
      <div css={[tw`flex flex-col justify-center items-center`]}>
        <Container>
          <Columns>
            <MediumThreeQuarters>
                <IconJobSecurity />
            </MediumThreeQuarters>
            <MediumOneQuarter>
              <TextQuarter css={[
                tw`mt-6`
              ]}>
                It is estimated that by 2024 there will be over 19,400 job openings created in the commercial road transport industry.
              </TextQuarter>
            </MediumOneQuarter>
            <SmallOneQuarter></SmallOneQuarter>
          </Columns>
        </Container>

        <NextPageContainer>
          <NextPageButton
            onClick={nextButtonClicked}
            label=""
          />
        </NextPageContainer>
      </div>
    </SlideSection>
  )
}

const TitleWrapper = styled.div`
  ${tw`flex flex-col items-center justify-center mt-24 md:mt-0`}
`
const TextQuarter = styled.div`
  font-family: interstate; font-size: 26px; line-height: 31.2px;
  @media (max-width: 768px) {
    font-size: 22px; 
    line-height: 26px;
    width: 76vw;
  }
  ${tw`flex flex-col flex-wrap flex-row text-center justify-center`}
`
const SmallOneQuarter = styled.div`
  ${tw`lg:w-1/12 flex flex-col items-center justify-center`}
`

export default JobSlide
